// @flow
import React from "react"
import Page from "pages/_Page"
import SectionHero from "./SectionHero"
import SectionFooter from "components/SectionFooter"
import { WhiteWrap } from "componentsStyled/Layout/WhiteWrap"
import { SideContent, SpreadContainer } from "componentsStyled/LoggedOut"
import { StyledContainer as Container, StyledText as Text } from "./styled"

const AffiliateWelcomePage = () => (
  <Page>
    <WhiteWrap>
      <Container>
        <SectionHero />
        <SpreadContainer>
          <SideContent>
            <Text lh={3}>
              Welcome! You're up and running on awayco, you'll be receiving an email shortly
              with all the information you'll need to know for using our tools.

              We will also send an email to you when you receive your
              first booking. Did you know that the average spend per booking on
              Awayco is AUD$60?
            </Text>
            <Text lh={3}>
              The Awayco Team
              <br/>
              #rentwithconfidence
            </Text>
          </SideContent>
        </SpreadContainer>
      </Container>
    </WhiteWrap>
    <SectionFooter />
  </Page>
)

export default AffiliateWelcomePage



// WEBPACK FOOTER //
// ./src/pages/AffiliateWelcome/index.js